(function (){
    'use strict';

    angular
        .module('services')
        .service('CostCenterService', CostCenterService);

    CostCenterService.$inject = ['$http', 'API_BASE'];

    function CostCenterService ($http, API_BASE) {
        var service = this;

        service.getInvoicesCostCenterCategory = getInvoicesCostCenterCategory;
        service.getInvoicesCostCenterSubcategory = getInvoicesCostCenterSubcategory;

        function getInvoicesCostCenterCategory() {
            return $http.get(API_BASE + '/invoice/cost-center/categories/list');
        }

        function getInvoicesCostCenterSubcategory(category_id) {
            return $http.get(API_BASE + '/invoice/cost-center/subcategories/'+category_id+'/list');
        }
    }
})();